<template>
    <div :class="{ 'fixed': isFixed }" class="row align-items-center container-full hide-nav-on-mobile fixed-element">
        <div class="col-header logo-container">
            <router-link :to="{ name: 'home' }">
                <img class="logo-nav" src="@/assets/images/logo-padrao-color.png" />
            </router-link>
        </div>
        <div class="col-header search-container">
            <div class="input-group mb-3 search">
                <input 
                    type="text"
                    class="form-control"
                    placeholder="Digite o nome do produto"
                    aria-label="Group Name"
                    aria-describedby="button-addon2"
                    @keyup.enter="searchGroup"
                    v-model="groupName"
                    >
                <div class="input-group-append">
                    <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="searchGroup">Buscar</button>
                </div>
            </div>
        </div>
        <div class="col-header d-flex header-links">
            <router-link class="mr-3" :to="{ name: 'helpcenter', params: { tab: 1 } }">
                Ajuda
            </router-link>
            <!-- <router-link :to="{ name: 'login' }" class="mr-3">Minha Conta</router-link> -->
            <div v-if="!loggedIn">
                <router-link class="dropdown-item" :to="{ name: 'login' }">
                    Minha Conta
                </router-link>
            </div>
            <a v-else class="nav-link dropdown-toggle" href="#" id="minha-conta" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="font-weight:300; margin: 0 10px 0 0; padding:0;">
                <img class="icon" src="@/assets/icons/user-alt.svg" alt="Padão Color" />
                {{loggedUser}}
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdown">    
                <router-link class="dropdown-item" :to="{ name: 'userdata' }">
                    Meus Dados
                </router-link>
                <router-link class="dropdown-item" :to="{ name: 'usercompras' }">
                    Minhas Compras
                </router-link>
                <router-link class="dropdown-item" :to="{ name: 'userfavorites' }">
                    Meus Favoritos
                </router-link>
                <span class="dropdown-item"  @click="logout">
                    Sair
                </span>
            </div>
            
            <router-link :to="{ name: 'cart' }" style="position: relative;">
                <img class="icons-nav" src="@/assets/icons/cart.png" />
                <div class="cart-pushup" v-if="itemCount">
                    <span>{{ itemCount }}</span>
                </div>
            </router-link>
        </div>
    </div>
    <nav class="navbar navbar-expand-lg container">
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav mr-auto">
                <a class="navbar-brand" href="#" @click="toggleSidebar()">
                    <img src="@/assets/icons/menu.png" />
                </a>
                <li class="nav-item dropdown">
                    <a
                        v-for="item in megaMenuItems"
                        @click="mouseEvent($event, 'item', item.key)"
                        :key="item.key"
                        class="nav-link dropdown-toggle"
                    >
                        {{ item.label }}
                    </a>
                </li>
                <li class="nav-item dropdown" >
                    <a class="nav-link dropdown-toggle" href="#" id="negocio" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Para o seu negócio
                    </a>
                    <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <template v-for="item in byBusiness">
                            <router-link class="dropdown-item" :to="{ name: 'seunegocio', params: { categoryId: item.id, categoryName: item.nome } }">
                                {{item.nome}}
                            </router-link>
                        </template>
                    </div>
                </li>
                
                <li class="nav-item dropdown" v-for="item in menuItems">
                    <a class="nav-link dropdown-toggle" href="#" :id="item.none" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    {{item.nome}}
                    </a>
                    <div v-if="item.grupos">
                        <div :class="{ 'dropdown-menu-col-2': item.grupos.length > 15 }" class="dropdown-menu" aria-labelledby="navbarDropdown">
                            <template v-for="grupo in item.grupos">
                                <router-link class="dropdown-item" :to="{ name: 'produto', params: { groupId: grupo.id, groupName: grupo.nome } }">
                                    {{grupo.nome}}
                                </router-link>
                            </template>
                        </div>
                    </div>
                    
                    <div v-else class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <template v-for="grupo in item.grupos">
                            <router-link class="dropdown-item" :to="{ name: 'produto', params: { groupId: grupo.id, groupName: grupo.nome } }">
                                {{grupo.nome}}
                            </router-link>
                        </template>
                    </div>
                </li>
                
            </ul>
        </div>
        <div :class="['sidebar', { 'is-collapsed': isCollapsed }]">
            <div class="sidebar-content">
                <img src="@/assets/images/logobrancopadrao.png" alt="Padrão Color" class="w-100 px-5 mb-4" style="width: 100px;"/>
                <strong>Institucional</strong>
                <ul>
                    <li>
                        <router-link @click="toggleSidebar" :to="{ name: 'aboutus'}">
                            Sobre Nós
                        </router-link>
                    </li>
                    <!-- <li>Padrão na Imprensa</li> -->
                    <li>
                        <router-link @click="toggleSidebar" :to="{ name: 'policies'}">
                            Política de Privacidade
                        </router-link>
                    </li>
                    <li>
                        <router-link @click="toggleSidebar" :to="{ name: 'ourstores'}">
                            Nossas Lojas
                        </router-link>
                    </li>
                    <li>
                        <router-link @click="toggleSidebar" :to="{ name: 'novopadrao'}">
                            Novo Padrão
                        </router-link>
                    </li>
                    <li>
                        <router-link @click="toggleSidebar" :to="{ name: 'contact'}">
                            Contatos
                        </router-link>
                    </li>
                    <li>
                        <router-link @click="toggleSidebar" :to="{ name: 'trabalheconosco'}">
                            Faça Parte da Nossa Equipe
                        </router-link>
                    </li>
                    <li>
                        <router-link @click="toggleSidebar" :to="{ name: 'sejarevendedor'}">
                            Seja um Revendedor
                        </router-link>
                    </li>
                    <li><a href="https://blog.padraocolor.com.br/?p=1070" target="_blank">Transparência e Igualdade Salarial</a></li>
                </ul>
                <strong>Informações</strong>
                <ul>
                    <li>
                        <router-link @click="toggleSidebar" :to="{ name: 'helpcenter', params: { tab: 1 }}">
                            Central de Ajuda
                        </router-link>
                    </li>
                    <!-- <li>Tutoriais</li> -->
                    <li>
                        <router-link @click="toggleSidebar" :to="{ name: 'downloads'}">
                            Downloads
                        </router-link>
                    </li>
                    <li>
                        <router-link @click="toggleSidebar" :to="{ name: 'pickuppoint'}">
                            Pontos de retirada
                        </router-link>
                    </li>
                    <li>
                        <router-link @click="toggleSidebar" :to="{ name: 'artCreation'}">
                            Criação de Arte
                        </router-link>
                    </li>
                </ul>
                <strong>Conteúdo</strong>
                <ul>
                    <li>
                        <router-link @click="toggleSidebar" :to="{ name: 'glossario'}">
                            Glossário
                        </router-link>
                    </li>
                    <li><a href="https://www.instagram.com/padraocolor/" target="_blank">Instagram</a></li>
                    <li><a href="https://www.facebook.com/padraocolor/?locale=pt_BR" target="_blank">Facebook</a></li>
                    <li><a href="https://blog.padraocolor.com.br" target="_blank">Blog</a></li>
                    <li><a href="https://blog.padraocolor.com.br/?cat=7" target="_blank">Dicas e Tutoriais</a></li>
                </ul>
                
                <strong>Utilidades</strong>
                <ul>
                    <li>
                        <router-link @click="toggleSidebar" :to="{ name: 'artPolices'}">
                            Normas de Envio de Arte
                        </router-link>
                    </li>
                    <li>
                        <router-link @click="toggleSidebar" :to="{ name: 'downloads'}">
                            System Color
                        </router-link>
                    </li>
                    <li>
                        <router-link @click="toggleSidebar" :to="{ name: 'gabaritos'}">
                            Gabaritos
                        </router-link>
                    </li>
                </ul>
                <strong>Comercial</strong>
                <ul>
                    <li>
                        <router-link @click="toggleSidebar" :to="{ name: 'specialprojects'}">
                            Projetos Especiais
                        </router-link>
                    </li>
                    <li>
                        <router-link @click="toggleSidebar" :to="{ name: 'vendascorporativas'}">
                            Venda Corporativa
                        </router-link>
                    </li>
                    <li>
                        <router-link @click="toggleSidebar" :to="{ name: 'sejafornecedor'}">
                            Seja um fornecedor
                        </router-link>
                    </li>
                    <li>
                        <router-link @click="toggleSidebar" :to="{ name: 'entregapersonalizada'}">
                            Entrega Personalizada
                        </router-link>
                    </li>
                    <li>
                        <router-link @click="toggleSidebar" :to="{ name: 'resellercategories'}">
                            Categorias de Revendedor
                        </router-link>
                    </li>
                </ul>
            </div>
            <button @click="toggleSidebar()">
                .
            </button>
        </div>
        <!-- <div class="items">
            <a
            v-for="item in megaMenuItems"
            @mouseover="mouseEvent($event, 'item', item.key)"
            :key="item.key"
            class="item"
            >
            {{ item.label }}
            </a>
        </div> -->
    </nav>
    <MegaMenu v-if="showMegaMenu" />
    <MegaMenuMobile v-if="showMegaMenuMobile" />
  
  <nav class="show-on-mobile" style="margin: 0 auto;">
    <div class="row align-items-center mt-4 mb-3 container" style="padding: 0 0 0 22px !important;">
        <div class="col-4 logo-container">
            <router-link :to="{ name: 'home' }">
                <img class="logo-nav" src="@/assets/images/logo-padrao-color.png" />
            </router-link>
        </div>
        <div class="col-6 d-flex header-links p-0">
            <router-link class="mr-3" :to="{ name: 'helpcenter', params: { tab: 1 } }">
                Ajuda
            </router-link>
            <div v-if="!loggedIn">
                <router-link class="dropdown-item" :to="{ name: 'login' }" style="padding: 5px;">
                    Minha Conta
                </router-link>
            </div>
            <a v-else class="nav-link dropdown-toggle" href="#" id="minha-conta" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="font-weight:300; margin: 0 10px 0 0; padding:0;">
                <img class="icon" src="@/assets/icons/user-alt.svg" alt="Padão Color" />
                {{loggedUser}}
            </a>            
            <div class="dropdown-menu" aria-labelledby="navbarDropdown">    
                <router-link class="dropdown-item" :to="{ name: 'userdata' }">
                    Meus Dados
                </router-link>
                <router-link class="dropdown-item" :to="{ name: 'usercompras' }">
                    Minhas Compras
                </router-link>
                <router-link class="dropdown-item" :to="{ name: 'userfavorites' }">
                    Meus Favoritos
                </router-link>
                <span class="dropdown-item"  @click="logout">
                    Sair
                </span>
            </div>
        </div>
        <div class="col-2">
            <router-link :to="{ name: 'cart' }" style="position: relative;">
                <img class="icons-nav" src="@/assets/icons/cart.png" />
                <div class="cart-pushup" v-if="itemCount">
                    <span>{{ itemCount }}</span>
                </div>
            </router-link>
        </div>
    </div>
    <!-- <div class="d-flex justify-content-center align-items-center my-2">
        <span class="mr-2" style="font-size: 11px;">Siga nossas redes: </span>
        <img class="icons-top-header mr-2" src="@/assets/icons/youtube.png" />
        <img class="icons-top-header mr-2" src="@/assets/icons/facebook.png" />
        <img class="icons-top-header" src="@/assets/icons/instagram.png" />
    </div> -->
    <div class="input-group px-4 mb-3 search">
        <input
            type="text"
            class="form-control"
            placeholder="Digite o nome do produto"
            aria-label="Group Name"
            aria-describedby="button-addon2"
            @keyup.enter="searchGroup"
            v-model="groupName"
        >
        <div class="input-group-append">
            <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="searchGroup"><img  src="@/assets/icons/lupa.png" /></button>
        </div>
    </div>
    <nav class="mt-2 mb-4 show-nav-on-mobile">
        <img @click="toggleSidebar()" src="@/assets/icons/menu.png" />
        <div class="btn-group nav-dropdown">
            <a
                v-for="item in megaMenuItems"
                @click="mouseEventMobile($event, 'item', item.key)"
                :key="item.key"
                class="nav-link dropdown-toggle"
            >
                {{ item.label }}
            </a>
        </div>
        <div class="btn-group nav-dropdown">
            <a class="nav-link dropdown-toggle" href="#" id="negocio-mobile" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                Por negócio
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                <template v-for="item in byBusiness">
                    <router-link class="dropdown-item" :to="{ name: 'seunegocio', params: { categoryId: item.id, categoryName: item.nome } }">
                        {{item.nome}}
                    </router-link>
                </template>
            </div>
        </div>
    </nav>
  </nav>
  <nav class="mt-2 mb-4 show-nav-on-mobile-landscape">
        <img @click="toggleSidebar()" src="@/assets/icons/menu.png" />
        <div class="btn-group nav-dropdown">
            <a
                v-for="item in megaMenuItems"
                @click="mouseEventMobile($event, 'item', item.key)"
                :key="item.key"
                class="nav-link dropdown-toggle"
            >
                {{ item.label }}
            </a>
        </div>
        <div class="btn-group nav-dropdown">
            <a class="nav-link dropdown-toggle" href="#" id="negocio-mobile" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                Por negócio
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                <template v-for="item in byBusiness">
                    <router-link class="dropdown-item" :to="{ name: 'seunegocio', params: { categoryId: item.id, categoryName: item.nome } }">
                        {{item.nome}}
                    </router-link>
                </template>
            </div>
        </div>
        <ul>
            <li class="nav-item dropdown" v-for="item in menuItems.slice(0, 2)">
                    <a class="nav-link dropdown-toggle" href="#" :id="item.none" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    {{item.nome}}
                    </a>
                    <div v-if="item.grupos">
                        <div :class="{ 'dropdown-menu-col-2': item.grupos.length > 15 }" class="dropdown-menu" aria-labelledby="navbarDropdown">
                            <template v-for="grupo in item.grupos">
                                <router-link class="dropdown-item" :to="{ name: 'produto', params: { groupId: grupo.id, groupName: grupo.nome } }">
                                    {{grupo.nome}}
                                </router-link>
                            </template>
                        </div>
                    </div>
                    
                    <div v-else class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <template v-for="grupo in item.grupos">
                            <router-link class="dropdown-item" :to="{ name: 'produto', params: { groupId: grupo.id, groupName: grupo.nome } }">
                                {{grupo.nome}}
                            </router-link>
                        </template>
                    </div>
                </li>
        </ul>
    </nav>
</template>

<script>
    import {ConfigDBMixin} from '@/database/config.js'
    import {GroupDBMixin} from '@/database/group.js'
    import MegaMenu from '@/components/MegaMenu.vue'
    import MegaMenuMobile from '@/components/MegaMenuMobile.vue'
    import eventBus from "../eventBus";
    import { inject } from 'vue'
    import { mapState, mapGetters, mapActions } from 'pinia';
    import { useCartStore } from '../stores/cartStore';
    import { environment } from '@/stores/environment';
    import { authService } from '@/services/authService';

    export default {
        mixins: [ConfigDBMixin, GroupDBMixin],
        components: {
            MegaMenu,
            MegaMenuMobile
        },
        data() {
            return {
                isFixed: false,
                foldLine: 400,
                groupName: "",
                isCollapsed: true,
                loggedUser: '',
                userToken: null,
                menuItems: [],
                byBusiness: [],
                megaMenuItems: [
                    { key: "products", label: "Todos os Produtos" },
                    
                ],
                showMegaMenu: false,
                showMegaMenuMobile: false,
            }
        },
        computed: {
            ...mapState(useCartStore, ['items']),
            ...mapGetters(useCartStore, ['itemCount']),
            loggedIn() {
                const authData = authService.getAuthData();
                
                if (authData) {
                    this.userToken = authData.token;
                    this.loggedUser = authData.user;
                    return this.userToken;
                } else {
                    this.userToken = null;
                    this.loggedUser = '';
                    return null;
                }
            }
        },
        methods: {
            ...mapActions(useCartStore, ['removeItem']),
            ...mapActions(useCartStore, ['addItem']),
            ...mapActions(useCartStore, ['addItemOnLoadPage']),
            ...mapActions(useCartStore, ['clearCart']),

            nameCurrentEvent(name) {
                this.name = name;
                // console.log(name);
            },

            handleScroll() {
                const scrollPosition = window.scrollY || window.pageYOffset;
                this.isFixed = scrollPosition > this.foldLine;
            },
            searchGroup() {
                // //console.log("Buscou")
                this.$router.push({ path: `/busca/${this.groupName}` });
                this.groupName = ''
            },
            toggleSidebar() {
                this.isCollapsed = !this.isCollapsed
            },
            logout() {
                authService.clearAuthData();
                this.userToken = null;
                this.loggedUser = '';
                
                if (this.$router.currentRoute.value.name == 'home') {
                    location.reload();
                } else {
                    this.$router.push({ name: 'home' });
                }
            },
            mouseEvent(event, source, key = "") {
                if (source === "item") {
                    event.stopPropagation();
                }
                this.showMegaMenu = key === "products";
            },
            mouseEventMobile(event, source, key = "") {
                // console.log("Mouse", key)
                if (source === "item") {
                    event.stopPropagation();
                }
                this.showMegaMenuMobile = key === "products";
            },
            async getMenu() {
                const data = await this.getMenuItems();
                this.menuItems.push(...data)
                // console.log("menu carregado", this.menuItems)
            },
            async loadByBusiness() {
                const data = await this.getByBusiness();
                this.byBusiness.push(...data)
                // console.log("por negocio", this.byBusiness)
            },
        },
        beforeDestroy() {
            window.removeEventListener('scroll', this.handleScroll);
        },
        mounted(){
            window.addEventListener('scroll', this.handleScroll);
            eventBus.on('hide-mega-menu', () => {
                this.showMegaMenu = false;
            });
            eventBus.on('hide-mega-menu-mobile', () => {
                this.showMegaMenuMobile = false;
            });
            this.getMenu();
            this.loadByBusiness();
            if (localStorage.getItem("cart")) {
                const getCartItens = localStorage.getItem('cart')
                const parsedCartItens = JSON.parse(getCartItens)
                // this.cartItems = parsedCartItens.length
                this.clearCart()
                for (const item of parsedCartItens) {
                    this.addItemOnLoadPage(item);
                }
                
            }
        },
        // beforeDestroy() {
        //     eventBus.$off("hide-mega-menu");
        // },
    }
</script>
<style lang="scss">
    .dropdown-menu-col-2.dropdown-menu.show {
        width: 500px;
        left: -300px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        a {
            width: 50%;
            word-wrap: break-word;
            white-space: break-spaces;
        }
    }
    .fixed-element {
        margin: 15px auto;
        transition: position 0.3s ease;
        background: #f5f5f5;
        &.container-full {
            width: 100%;
            padding: 20px !important
        }
    }

    .fixed {
        position: fixed;
        top: 0; /* or any value to adjust the fixed element's top position */
        left: 0;
        z-index: 998;
        margin-top: 0 !important;
        .search {
            padding-top: 13px;
        }
    }
    .logo-nav {
        width: 145px;
        max-width: 100%;
    }
    .nav {
        display: flex;
    }
    .nav-link.dropdown-toggle {
        font-weight: 500;
    }
    .header-links {
        justify-content: flex-end;
        align-items: center;
        a {
            color: #000
        }
    }
    .logo-container {
        text-align: left;
    }
    .dropdown-toggle {
        color: #000;
        .icon {
            width: 15px;
        }
    }
    .cart-pushup {
        text-align:center;
        position: absolute;
        top: -9px;
        right: -17px;
        width: 20px;
        height: 20px;
        background: #ff4341;
        color: #fff;
        font-size: 12px;
        font-weight: 700;
        border-radius: 100%;
        span {
            font-weight: 700;
            display: block;
            margin-top: 1px;
        }
    }
    .col-header.logo-container {
        margin-right: 50px;
    }
    .col-header.search-container {    
        flex: 1;
        margin-right: 50px;
    }
    .navbar-nav {
        flex-wrap: wrap;
    }
    .sidebar {
        &.is-collapsed {
            display:none;
        }
        display:flex;
        position: fixed;
        top: 0;
        left: 0;
        background: rgba(0,0,0,0.7);
        width: 100%;
        height: 100%;
        z-index: 999;
        button {
            flex: auto;
            background: transparent;
            border: none;
        }
        .sidebar-content {
            width: 330px;
            height: 100%;
            background: #FF463A;
            color: #fff;
            text-align: left;
            padding: 10px 20px;
            overflow-y: auto;
            strong {
                font-weight: 600;
            }
            ul {
                list-style: none;
                padding-left: 25px;
            }
            li a {
                color: #fff;
                text-decoration: none;
            }
        }
    }
    .search {
        input {
            height: 45px;
            border-right: 0;
            border-radius: 30px 0 0 30px;
        }
        .input-group-append {
            background: #fff;
            padding: 4px;
            height: 45px;
            border: 1px solid #ced4da;
            border-radius: 0 30px 30px 0;
        }
        .btn.btn-outline-secondary {
            background: #FF463A;
            color: #fff;
            border-radius: 50px;
            border: none;
            padding: 0 30px;
        }
    }
    .btn-group.nav-dropdown {
        .dropdown-toggle {
            border: none;
            background: transparent;
            box-shadow: none;
        }
    }
    .hide-nav-on-mobile {
        display: flex !important;
    }
    .show-nav-on-mobile {
        display: none !important;
    }
    .show-nav-on-mobile-landscape {
        display: none !important;
    }
    @media screen and (max-width: 490px) {
        .mobile-mt-2 {
            margin-top: 2rem;
        }
        .hide-nav-on-mobile {
            display: none !important;
        }
        .show-nav-on-mobile {
            display: flex !important;
            padding: 0 10px;
            align-items: center;
            justify-content: space-between;
        }
        .search .btn.btn-outline-secondary {
            padding: 0 15px;
        }
        .navbar.navbar-expand-lg {
            height: 1px;
            padding: 0;
        }
    }
    @media screen and (max-width: 900px) and (min-width: 791px) {
        .navbar.navbar-expand-lg {
            height: 1px;
            padding:0;
            margin: 0;
        }
        .show-nav-on-mobile-landscape {
            display: flex !important;
            align-items: center;
            padding: 0 20px;
            justify-content: center;
            ul {
                display: flex;
                list-style: none;
                margin: 0;
                padding: 0;
            }
        }
        .navbar-toggler {
            display: none;
        }
    }
</style>